var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"start-up-box"}},[_c('div',{class:_vm.isLogo ? 'logo logo-active' : 'logo'},[_c('img',{staticClass:"logo1",attrs:{"src":require("../../assets/images/logo.ico.png"),"alt":""}})]),_c('div',{staticClass:"logo-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }